import { isNil } from "lodash-es";
import Link from "next/link";
import { useRouter } from "next/router";
import * as React from "react";
import type { UsersCampaignLabelType } from "@graphql/__generated__/types";
import { GTMEvent, GTMEvents } from "@libs/utils/gtm";
import { isExternalUrl } from "@libs/utils/url";
import styles from "./index.module.css";

type Props = {
  campaignLabel: UsersCampaignLabelType;
};

const CampaignLabelItem: React.FC<Props> = ({ campaignLabel }) => {
  const isExternalLink = isExternalUrl(campaignLabel.linkUrl ?? "");
  const router = useRouter();
  const shopUuid =
    typeof router.query.uuid === "string" ? router.query.uuid : "";

  // TODO: ポイント用のロジック追加をお願いいたします
  // icon（icon_fansta_point.svg）、テキスト（ネット予約でポイントもらえる）
  const childContent = (
    <div className={styles.campaignLabel}>{campaignLabel.displayText}</div>
  );

  return (
    <li>
      {isNil(campaignLabel.linkUrl) ? (
        childContent
      ) : (
        <Link
          href={campaignLabel.linkUrl}
          className={styles.campaignLabelLink}
          target={isExternalLink ? "_blank" : "_self"}
          onClick={() =>
            GTMEvent(
              GTMEvents.campaignLabelPressed(
                shopUuid,
                campaignLabel.linkUrl ?? ""
              )
            )
          }
        >
          {childContent}
        </Link>
      )}
    </li>
  );
};

export default CampaignLabelItem;
